const PAGE_NAME = 'CREATE_TASK';
const NAME = 'createTask';

export default { PAGE_NAME, NAME };
